import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Login.css";
import "./Policy.css";

const SUPPORT_LINK = "/support?subject=Account%20deletion%20request";

export default function AccountDeletion() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-page">
      <Link to="/login" className="policy-back">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M19 12H5M12 5l-7 7 7 7" />
        </svg>
        Back to Login
      </Link>

      <div className="centered-logo-container">
        <div className="logo-wrapper">
          <img src="/MP%20Full%20Color@3x.png" alt="Masters Path" className="site-logo-img" />
        </div>
      </div>

      <div className="policy-card">
        <h1>Account and Data Deletion</h1>
        <p className="policy-effective">Masters Path Performance Dashboard</p>

        <hr className="policy-divider" />

        <div className="policy-section">
          <h2>How Accounts Work</h2>
          <p>
            The Masters Path Performance Dashboard is a business operations application. Accounts are
            not self-registered—each one is created and administered by the customer organization
            (the dealership or franchise group) that subscribes to the Platform, and the performance
            data in the account belongs to that organization.
          </p>
          <p>
            Because of this, deletion requests are normally fulfilled through your account owner or
            administrator, who can deactivate or remove a user from the dealership at any time. If
            you would prefer to submit the request to us directly, you can do so using either method
            below.
          </p>
        </div>

        <div className="policy-section">
          <h2>How to Request Deletion</h2>
          <p>
            <strong style={{ color: "rgba(220,235,255,0.92)" }}>Option 1—Ask your account owner.</strong>{" "}
            Contact the owner or administrator at your dealership and ask them to remove your account.
            They can do this from the Platform directly.
          </p>
          <p>
            <strong style={{ color: "rgba(220,235,255,0.92)" }}>Option 2—Contact us.</strong> Submit a
            request through our <Link to={SUPPORT_LINK} style={{ color: "#ffb57a" }}>support form</Link>{" "}
            or email{" "}
            <a href="mailto:hb.masterspath@gmail.com?subject=Account%20deletion%20request" style={{ color: "#ffb57a" }}>
              hb.masterspath@gmail.com
            </a>{" "}
            with the subject line &ldquo;Account deletion request.&rdquo; Please include the email
            address on the account and the name of your dealership so we can verify the request. We
            will confirm the request with your account owner before removing the account, since the
            organization is the owner of the underlying business records.
          </p>
          <div className="policy-contact-block">
            <p>
              <strong style={{ color: "rgba(220,235,255,0.92)" }}>Masters Path Consulting LLC</strong><br />
              <a href="mailto:hb.masterspath@gmail.com?subject=Account%20deletion%20request">hb.masterspath@gmail.com</a>
            </p>
          </div>
        </div>

        <div className="policy-section">
          <h2>What Is Removed</h2>
          <p>
            When an account is deleted, we remove the information used to identify and sign in to
            that account:
          </p>
          <ul>
            <li>Email address and username, which are replaced with a non-functional placeholder</li>
            <li>Password and login credentials—the account can no longer be accessed</li>
            <li>Phone number</li>
          </ul>
          <p>
            The account is also removed from the employee lists and selection menus used elsewhere in
            the Platform, and the person no longer appears on current scoreboards or leaderboards.
          </p>
        </div>

        <div className="policy-section">
          <h2>What Is Retained</h2>
          <p>
            The employee's name is retained on performance records that were already recorded—daily
            activity logs, sales and finance entries, and the historical reporting the dealership
            runs from them. These records belong to the dealership rather than to the individual
            account, and removing the name from them would destroy the dealership's own history. A
            departed employee's name therefore remains visible to authorized staff at that dealership
            when they review past periods.
          </p>
          <p>
            We also retain the dealership's business records themselves—sales, finance and insurance,
            service, and other performance figures—along with the employment record showing the role
            held and the dates worked.
          </p>
          <p>
            We may retain additional information where we have a legal, accounting, or audit
            obligation to do so. Retention periods are described in our{" "}
            <Link to="/privacy" style={{ color: "#ffb57a" }}>Privacy Policy</Link>.
          </p>
        </div>

        <div className="policy-section">
          <h2>How Long It Takes</h2>
          <p>
            We acknowledge deletion requests within two business days and complete verified requests
            within thirty days. If we are unable to fulfill a request—for example, if the account
            owner indicates that records must be preserved for a legal or audit reason—we will
            explain why in our reply.
          </p>
        </div>
      </div>

      <div className="policy-footer">
        <span>© {new Date().getFullYear()} Masters Path Consulting LLC</span>
        <span className="footer-sep">·</span>
        <Link to="/privacy">Privacy Policy</Link>
        <span className="footer-sep">·</span>
        <Link to="/terms">Terms of Service</Link>
        <span className="footer-sep">·</span>
        <Link to="/support">Support</Link>
      </div>
    </div>
  );
}
